import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "2021"
    }}>{`2021`}</h1>
    <h2 {...{
      "id": "december-23-2021"
    }}>{`December 23, 2021`}</h2>
    <h3 {...{
      "id": "android-edge-120"
    }}>{`Android Edge 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Adds XDM Implementation Details to each Experience Event sent to the Edge Network.`}</li>
    </ul>
    <h2 {...{
      "id": "december-22-2021"
    }}>{`December 22, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-332"
    }}>{`iOS AEPCore 3.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Stability improvements for Configuration extension and full screen messages.`}</li>
      <li parentName="ul">{`Configuration now allows for empty appId to reset the previously set appId value.`}</li>
      <li parentName="ul">{`Logging improvements for extensions registration flow.`}</li>
      <li parentName="ul">{`The Event Hub shares wrapper type in its shared state.`}</li>
      <li parentName="ul">{`Adds new messaging event type and sources.`}</li>
      <li parentName="ul">{`Deprecates SystemInfoService getApplicationVersion API.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepidentity-332"
    }}>{`iOS AEPIdentity 3.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixes a bug where Identity.getIdentifiers API failed to encode the identifiers.`}</li>
      <li parentName="ul">{`Fixes intermittent issue for GetUrlVariables and AppendToUrl APIs when custom Analytics identifiers are being used.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepedge-120"
    }}>{`iOS AEPEdge 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Adds XDM Implementation Details to each Experience Event sent to the Edge Network.`}</li>
      <li parentName="ul">{`Fixes generic network error format to conform to EdgeEventError type so they are dispatched back to the caller correctly.`}</li>
    </ul>
    <h2 {...{
      "id": "december-20-2021"
    }}>{`December 20, 2021`}</h2>
    <h3 {...{
      "id": "react-native-plugins-with-swift-sdks-beta"
    }}>{`React Native Plugins with Swift SDKs (Beta)`}</h3>
    <p>{`The following Adobe Experience Platform React Native plugins are integrated with Android SDKs and iOS `}<strong parentName="p">{`Swift`}</strong>{` SDKs.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepcore"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepcore`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepuserprofile"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepuserprofile`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepedge"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepedge`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepedgeidentity"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepedgeidentity`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepedgeconsent"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepedgeconsent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepmessaging"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepmessaging`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepassurance"
        }}>{`https://www.npmjs.com/package/@adobe/react-native-aepassurance`}</a></li>
    </ul>
    <p>{`For more details, see the documentation and release notes in the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native"
      }}>{`aepsdk-react-native repository`}</a>{`.`}</p>
    <h2 {...{
      "id": "december-16-2021"
    }}>{`December 16, 2021`}</h2>
    <h3 {...{
      "id": "ios-aeprulesengine-110"
    }}>{`iOS AEPRulesEngine 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Add support for opperand function types.`}</li>
    </ul>
    <h2 {...{
      "id": "november-19-2021"
    }}>{`November 19, 2021`}</h2>
    <h3 {...{
      "id": "ios-aeptarget-312"
    }}>{`iOS AEPTarget 3.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where the Target qaMode parameters were not being attached to the `}<inlineCode parentName="li">{`retrieveLocationContent`}</inlineCode>{` API requests, once the Target preview selections were confirmed.`}</li>
    </ul>
    <h2 {...{
      "id": "november-9-2021"
    }}>{`November 9, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-331"
    }}>{`iOS AEPCore 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Date was not persisted correctly in iOS versions less than 13.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aeplifecycle-331"
    }}>{`iOS AEPLifecycle 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Added session start time to Lifecycle shared state.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepidentity-331"
    }}>{`iOS AEPIdentity 3.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the default Experience Cloud ID server URL was not used when the `}<inlineCode parentName="li">{`experienceCloud.server`}</inlineCode>{` configuration parameter was an empty string.`}</li>
    </ul>
    <h2 {...{
      "id": "november-5-2021"
    }}>{`November 5, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepmobileservices-303"
    }}>{`iOS AEPMobileServices 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixes crash when using an immutable dictionary for handling attribution data.`}</li>
    </ul>
    <h2 {...{
      "id": "october-22-2021"
    }}>{`October 22, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepanalytics-303"
    }}>{`iOS AEPAnalytics 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Add support for `}<inlineCode parentName="li">{`MobileCore.resetIdentities()`}</inlineCode>{` API. When this API is called, the Analytics identifiers and the Analytics hits queue are cleared.`}</li>
      <li parentName="ul">{`Removed retrieval and generation of `}<inlineCode parentName="li">{`Analytics tracking identifier (AID)`}</inlineCode>{`. Existing AID values stored on the device will continue to be loaded and used, however new visitors will not be assigned an AID value.`}</li>
    </ul>
    <h2 {...{
      "id": "october-22-2021-1"
    }}>{`October 22, 2021`}</h2>
    <h3 {...{
      "id": "ios-aeptarget-311"
    }}>{`iOS AEPTarget 3.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where the Target session ID was not being persisted in the local storage if the app was closed before session expiry.`}</li>
    </ul>
    <h2 {...{
      "id": "october-18-2021"
    }}>{`October 18, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepmobileservices-302"
    }}>{`iOS AEPMobileServices 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Includes deferred link info to Acquisition response event when available.`}</li>
    </ul>
    <h2 {...{
      "id": "september-20-2021"
    }}>{`September 20, 2021`}</h2>
    <h3 {...{
      "id": "ios-15-compatibility"
    }}>{`iOS 15 Compatibility`}</h3>
    <ul>
      <li parentName="ul">{`All Adobe Experience Platform Mobile SDKs for iOS have been functionally validated to be compatible with iOS 15.`}</li>
    </ul>
    <h2 {...{
      "id": "september-8-2021"
    }}>{`September 8, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepanalytics-302"
    }}>{`iOS AEPAnalytics 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where entire context data dictionary in track request was dropped if any of its key had non string value.`}</li>
    </ul>
    <h2 {...{
      "id": "september-3-2021"
    }}>{`September 3, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-330"
    }}>{`iOS AEPCore 3.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for dispatch event rules consequence.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aeplifecycle-330"
    }}>{`iOS AEPLifecycle 3.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Lifecycle extension now dispatches two new events `}<inlineCode parentName="li">{`applicationLaunch`}</inlineCode>{` and `}<inlineCode parentName="li">{`applicationClose`}</inlineCode>{` which contain Mobile Lifecycle metrics in XDM format.`}</li>
      <li parentName="ul">{`Fixed an issue where application upgrades were detected based on changes in `}<inlineCode parentName="li">{`CFBundleShortVersionString`}</inlineCode>{` instead of `}<inlineCode parentName="li">{`CFBundleVersion`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "mobile-core-tag-extension-v2120"
    }}>{`Mobile Core tag extension v2.1.20`}</h3>
    <ul>
      <li parentName="ul">{`New `}<inlineCode parentName="li">{`Foreground`}</inlineCode>{` and `}<inlineCode parentName="li">{`Background`}</inlineCode>{` event types to be used in rules for triggering actions based on Mobile Application Lifecycle XDM events.`}</li>
    </ul>
    <h3 {...{
      "id": "adobe-experience-platform-edge-network-tag-extension-v1012"
    }}>{`Adobe Experience Platform Edge Network tag extension v1.0.12`}</h3>
    <ul>
      <li parentName="ul">{`New `}<inlineCode parentName="li">{`Forward to Edge Network`}</inlineCode>{` action to be used with Mobile Core Application Lifecycle events.`}</li>
    </ul>
    <h2 {...{
      "id": "september-2-2021"
    }}>{`September 2, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepedge-112"
    }}>{`iOS AEPEdge 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Edge Network Extension now honors the timestamp set in XDM payload of Experience Event. If no timestamp is set then timestamp of `}<inlineCode parentName="li">{`Edge.sendEvent()`}</inlineCode>{` API call is used.`}</li>
    </ul>
    <h2 {...{
      "id": "august-25-2021"
    }}>{`August 25, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepmobileservices-301"
    }}>{`iOS AEPMobileServices 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where shared state was not being read correctly in response to some events.`}</li>
    </ul>
    <h2 {...{
      "id": "august-18-2021"
    }}>{`August 18, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-324"
    }}>{`iOS AEPCore 3.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed data race in `}<inlineCode parentName="li">{`Event`}</inlineCode>{` and `}<inlineCode parentName="li">{`ExtensionContainer`}</inlineCode>{` classes.`}</li>
      <li parentName="ul">{`Fixed a memory leak in `}<inlineCode parentName="li">{`EventHub.registerResponseListener`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "august-5-2021"
    }}>{`August 5, 2021`}</h2>
    <h3 {...{
      "id": "ios-aeptarget-310"
    }}>{`iOS AEPTarget 3.1.0`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`TargetRequest`}</inlineCode>{` class now provides a constructor with a new callback function named `}<inlineCode parentName="li">{`contentWithDataCallback`}</inlineCode>{`. When implemented, this callback provides:`}
        <ul parentName="li">
          <li parentName="ul">{`Target content; AND`}</li>
          <li parentName="ul">{`Data payload dictionary containing one or more of response tokens, Analytics payload, click metric Analytics payload (if available in the Target retrieve location content response with/ without a prior prefetch call)`}</li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`Note`}</strong>{`: This SDK extension, per previous behavior, will make requests to Adobe Analytics (if the Adobe Analytics extension is also implemented) with appropriate Target payloads for A4T functionality.`}</p>
    <ul>
      <li parentName="ul">{`Fixed an issue where the click notification was not being sent to Adobe Target for a retrieved mbox location upon the `}<inlineCode parentName="li">{`clickedLocation`}</inlineCode>{` API call.`}</li>
      <li parentName="ul">{`Added support for sending the click conversion A4T payload to Adobe Analytics for A4T-enabled Target activities when the `}<inlineCode parentName="li">{`clickedLocation`}</inlineCode>{` API is called.`}</li>
    </ul>
    <h2 {...{
      "id": "july-29-2021"
    }}>{`July 29, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-323"
    }}>{`iOS AEPCore 3.2.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in the `}<inlineCode parentName="li">{`PersistentHitQueue`}</inlineCode>{` where new hits can cause additional scheduled tasks.`}</li>
      <li parentName="ul">{`Improved handling of database errors in the `}<inlineCode parentName="li">{`PersistentHitQueue`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "july-16-2021"
    }}>{`July 16, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepmedia-301"
    }}>{`iOS AEPMedia 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Enabled debugging post processed data in Media Analytics Assurance workflow.`}</li>
    </ul>
    <h2 {...{
      "id": "july-13-2021"
    }}>{`July 13, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepplaces-301"
    }}>{`iOS AEPPlaces 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fix podspec and SPM configurations.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepaudience-302"
    }}>{`iOS AEPAudience 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support to handle the MobileCore.resetIdentities() API.`}</li>
    </ul>
    <h2 {...{
      "id": "july-2-2021"
    }}>{`July 2, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepuserprofile-301"
    }}>{`iOS AEPUserProfile 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug preventing proper data migration when presented with an `}<inlineCode parentName="li">{`app group`}</inlineCode>{` .`}</li>
    </ul>
    <h2 {...{
      "id": "june-30-2021"
    }}>{`June 30, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-322"
    }}>{`iOS AEPCore 3.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Remove double URL encoding of AEPIdentity identifiers.`}</li>
      <li parentName="ul">{`Prevent possible crash at shutdown in EventHub.`}</li>
    </ul>
    <h2 {...{
      "id": "june-28-2021"
    }}>{`June 28, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepassurance-300"
    }}>{`iOS AEPAssurance 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/experience-platform/assurance/home.html"
        }}>{`Adobe Experience Platform Assurance`}</a>{` for Adobe Experience Platform Mobile SDKs for iOS in Swift. This library is available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-assurance-ios"
        }}>{`open sourced project on Github`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "june-21-2021"
    }}>{`June 21, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-321"
    }}>{`iOS AEPCore 3.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Update version for bundled AEPIdentity 3.2.1 release.`}</li>
    </ul>
    <h2 {...{
      "id": "ios-aepidentity-321"
    }}>{`iOS AEPIdentity 3.2.1`}</h2>
    <ul>
      <li parentName="ul">{`Fixed a bug where `}<inlineCode parentName="li">{`Identity.syncIdentifier`}</inlineCode>{` and `}<inlineCode parentName="li">{`Identity.syncIdentifiers`}</inlineCode>{` APIs would ignore the authentication state settings.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-messaging-100"
    }}>{`iOS Messaging 1.0.0`}</h3>
    <ul>
      <li parentName="ul">{`The Adobe Experience Platform Messaging (AEPMessaging) mobile extension is now available in iOS! This extension enables push notifications and measurement for Adobe Journey Optimizer.`}</li>
    </ul>
    <h3 {...{
      "id": "adobe-journey-optimizer-tag-extension"
    }}>{`Adobe Journey Optimizer tag Extension`}</h3>
    <ul>
      <li parentName="ul">{`You can now find the `}<inlineCode parentName="li">{`Adobe Journey Optimizer`}</inlineCode>{` extension in the tag extensions catalog for mobile properties.`}</li>
    </ul>
    <h2 {...{
      "id": "june-10-2021"
    }}>{`June 10, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepedge-111"
    }}>{`iOS AEPEdge 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Development testing enhancements for Experience Edge.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-111"
    }}>{`Android Edge 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Adds support for events persistence for use-cases with low network connectivity or unexpected network errors.`}</li>
      <li parentName="ul">{`Development testing enhancements for Experience Edge.`}</li>
    </ul>
    <p>{`This SDK is compatible with Android Core 1.8.2 and above.`}</p>
    <h2 {...{
      "id": "june-8-2021"
    }}>{`June 8, 2021`}</h2>
    <h3 {...{
      "id": "ios-campaign-standard-300"
    }}>{`iOS Campaign Standard 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support `}<a parentName="li" {...{
          "href": "../../solution/adobe-campaign-standard/index.md"
        }}>{`Adobe Campaign Standard workflows`}</a>{` for Adobe Experience Platform Mobile SDKs for iOS in Swift. This extension library is `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-campaign-ios/"
        }}>{`available as an open source project on Github`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "june-7-2021"
    }}>{`June 7, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-320"
    }}>{`iOS AEPCore 3.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Support for handling identities request `}<inlineCode parentName="li">{`Event`}</inlineCode>{`'s in AEPIdentity`}</li>
      <li parentName="ul">{`Improve public visiblity of `}<inlineCode parentName="li">{`RuleConsequence`}</inlineCode></li>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`getDeviceModelNumber`}</inlineCode>{` to `}<inlineCode parentName="li">{`SystemInfoService`}</inlineCode></li>
      <li parentName="ul">{`Various additions to `}<inlineCode parentName="li">{`ThreadSafeDictionary`}</inlineCode></li>
      <li parentName="ul">{`Added the ability to make a network request with raw data that is not UTF encoded`}</li>
      <li parentName="ul">{`Fixed a bug where condition definitions that did not contain a value were not handled correctly`}</li>
      <li parentName="ul">{`Introduced an API to set button image data to the `}<inlineCode parentName="li">{`FloatingButton`}</inlineCode></li>
      <li parentName="ul">{`Added `}<inlineCode parentName="li">{`optimize`}</inlineCode>{` `}<inlineCode parentName="li">{`EventType`}</inlineCode></li>
      <li parentName="ul">{`Introduced an API to hide the `}<inlineCode parentName="li">{`FullscreenMessage`}</inlineCode></li>
      <li parentName="ul">{`Fixed a bug where token (~ timestampu) was not expanded correctly`}</li>
      <li parentName="ul">{`Introduced `}<inlineCode parentName="li">{`webViewDidFinishLoading`}</inlineCode>{` to `}<inlineCode parentName="li">{`FullScreenMessageDelegate`}</inlineCode></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Note: This release introduces breaking changes to the `}<inlineCode parentName="p">{`NetworkService`}</inlineCode>{` and the `}<inlineCode parentName="p">{`SystemInfoService`}</inlineCode>{`.`}</p>
    </blockquote>
    <h2 {...{
      "id": "june-4-2021"
    }}>{`June 4, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepmobileservices-300"
    }}>{`iOS AEPMobileServices 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Released the brand new Adobe Experience Platform Mobile Services iOS Swift SDK.`}</li>
    </ul>
    <h2 {...{
      "id": "june-1-2021"
    }}>{`June 1, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepplaces-300"
    }}>{`iOS AEPPlaces 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release of AEPPlaces.`}</li>
    </ul>
    <h2 {...{
      "id": "may-6-2021"
    }}>{`May 6, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-313"
    }}>{`iOS AEPCore 3.1.3`}</h3>
    <ul>
      <li parentName="ul">{`Update to use AEPRulesEngine 1.0.1.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aeprulesengine-101"
    }}>{`iOS AEPRulesEngine 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a Swift compatibility issue.`}</li>
    </ul>
    <h2 {...{
      "id": "may-5-2021"
    }}>{`May 5, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepmedia-300"
    }}>{`iOS AEPMedia 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support `}<a parentName="li" {...{
          "href": "../../solution/adobe-media-analytics/index.md"
        }}>{`Adobe Analytics - Media Analytics workflows`}</a>{` for Adobe Experience Platform Mobile SDKs for iOS in Swift. This extension library is `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-media-ios/"
        }}>{`available as an open source project on Github`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "april-29-2021"
    }}>{`April 29, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-312"
    }}>{`iOS AEPCore 3.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the URL session was not reused for the same host.`}</li>
      <li parentName="ul">{`Fixed a Swift compatibility issue.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepidentity-312"
    }}>{`iOS AEPIdentity 3.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Identity was blocked on the first launch if the configuration was invalid.`}</li>
    </ul>
    <h2 {...{
      "id": "april-13-2021"
    }}>{`April 13, 2021`}</h2>
    <h3 {...{
      "id": "identity-for-edge-network"
    }}>{`Identity for Edge Network`}</h3>
    <p>{`You can now find the Identity for Edge Network extension in the tag extensions catalog for mobile properties.`}</p>
    <h2 {...{
      "id": "april-12-2021"
    }}>{`April 12, 2021`}</h2>
    <h3 {...{
      "id": "consent-for-edge-network"
    }}>{`Consent for Edge Network`}</h3>
    <p>{`You can now find the Consent for Edge Network extension in the tag extensions catalog for mobile properties.`}</p>
    <h2 {...{
      "id": "april-9-2021"
    }}>{`April 9, 2021`}</h2>
    <h3 {...{
      "id": "ios-target-300"
    }}>{`iOS Target 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support `}<a parentName="li" {...{
          "href": "../../solution/adobe-target/index.md"
        }}>{`Adobe Target`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS in Swift. This library is available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-target-ios"
        }}>{`open source project on GitHub`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "april-8-2021"
    }}>{`April 8, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-311"
    }}>{`iOS AEPCore 3.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where incomplete event hub shared state was created before the event hub has been started.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepedge-110"
    }}>{`iOS AEPEdge 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Integration with AEPEdgeConsent 1.0.0 and collect consent preferences enforcement on requests to AEP Edge Network.`}</li>
      <li parentName="ul">{`Adds required dependency on AEPEdgeIdentity 1.0.0 that brings XDM IdentityMap support for custom identifiers.`}</li>
    </ul>
    <h3 {...{
      "id": "android-edge-110"
    }}>{`Android Edge 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Integration with EdgeConsent 1.0.0 and collect consent preferences enforcement on requests to AEP Edge Network.`}</li>
      <li parentName="ul">{`Adds required dependency on EdgeIdentity 1.0.0 that brings XDM IdentityMap support for custom identifiers.`}</li>
    </ul>
    <h3 {...{
      "id": "ios--android-edgeidentity-100"
    }}>{`iOS & Android EdgeIdentity 1.0.0`}</h3>
    <p>{`The Adobe Experience Platform Identity (AEPEdgeIdentity) mobile extension is now available on iOS and Android! This extension enables handling of user identity data from a mobile app when using the Adobe Experience Platform SDK and the Edge Network extension.`}</p>
    <h2 {...{
      "id": "april-5-2021"
    }}>{`April 5, 2021`}</h2>
    <h3 {...{
      "id": "ios--android-consent-100"
    }}>{`iOS & Android Consent 1.0.0`}</h3>
    <p>{`The Adobe Experience Platform Consent (AEPEdgeConsent) mobile extension is now available in iOS and Android! This extension enables consent preferences collection from your mobile app when using the Adobe Experience Platform Mobile SDK and the Edge Network extension. You can now find the `}<inlineCode parentName="p">{`Consent`}</inlineCode>{` extension in the tag extensions catalog for mobile properties.`}</p>
    <h2 {...{
      "id": "april-1-2021"
    }}>{`April 1, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepcore-310"
    }}>{`iOS AEPCore 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`New API - `}<inlineCode parentName="li">{`MobileCore.collectLaunchInfo()`}</inlineCode>{` - see API reference for more information.`}</li>
      <li parentName="ul">{`New API - `}<inlineCode parentName="li">{`MobileCore.resetIdentities()`}</inlineCode>{` - see API reference for more information.`}</li>
      <li parentName="ul">{`Added multiple new values to `}<inlineCode parentName="li">{`EventType`}</inlineCode>{` and `}<inlineCode parentName="li">{`EventSource`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed a bug causing regular listeners to receive paired response events.`}</li>
      <li parentName="ul">{`Fixed a bug preventing proper data migration from v4 and v5 SDK.`}</li>
      <li parentName="ul">{`The callback method passed to `}<inlineCode parentName="li">{`MobileCore.registerEventListener`}</inlineCode>{` now runs on a background thread.`}</li>
      <li parentName="ul">{`Improved logging for dictionaries.`}</li>
      <li parentName="ul">{`The EventHub's shared state dictionary now uses the full name of each registered extension as its key.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepidentity-310"
    }}>{`iOS AEPIdentity 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where privacy status was not correctly loaded from persistence.`}</li>
      <li parentName="ul">{`Advertising ID can now correctly be set after having an initial value of "zeroes" or empty.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepservices-310"
    }}>{`iOS AEPServices 3.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for UI Services.`}</li>
      <li parentName="ul">{`The Locale string used in HTTP Headers is now properly formatted.`}</li>
      <li parentName="ul">{`Fixed a bug that would sometimes prevent downloaded files from being properly unzipped.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepanalytics-301"
    }}>{`iOS AEPAnalytics 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support to handle internal analytics track request events`}</li>
      <li parentName="ul">{`Refactored code and updated doc comments`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepaudience-301"
    }}>{`iOS AEPAudience 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Updated syncedVisitorIds implementation to a map`}</li>
      <li parentName="ul">{`Fixed access modifer for two classes`}</li>
    </ul>
    <h2 {...{
      "id": "february-26-2021"
    }}>{`February 26, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepanalytics-300"
    }}>{`iOS AEPAnalytics 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support `}<a parentName="li" {...{
          "href": "../../solution/adobe-analytics/index.md"
        }}>{`Adobe Analytics`}</a>{` for Adobe Experience Platform Mobile SDKs for iOS in Swift. This library is available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-analytics-ios/"
        }}>{`open sourced project on Github`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "january-29-2021"
    }}>{`January 29, 2021`}</h2>
    <h3 {...{
      "id": "ios-audience-300"
    }}>{`iOS Audience 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support Adobe Audience for Adobe Experience Platform Mobile SDKs for iOS in Swift. This extension library is available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-audience-ios/"
        }}>{`open sourced project on Github`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "january-19-2021"
    }}>{`January 19, 2021`}</h2>
    <h3 {...{
      "id": "adobe-experience-platform-ios-core-sdks"
    }}>{`Adobe Experience Platform iOS Core SDKs`}</h3>
    <p>{`Adobe Experience Platform Mobile SDKs for iOS are now being made available on Swift. Mobile Core in Swift is available as an `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-core-ios/"
      }}>{`open sourced project on Github`}</a>{` and contains the following extensions:`}</p>
    <ul>
      <li parentName="ul">{`AEPCore 3.0.0`}</li>
      <li parentName="ul">{`AEPServices 3.0.0`}</li>
      <li parentName="ul">{`AEPIdentity 3.0.0`}</li>
      <li parentName="ul">{`AEPSignal 3.0.0`}</li>
      <li parentName="ul">{`AEPLifecycle 3.0.0`}</li>
      <li parentName="ul">{`AEPRulesEngine 1.0.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-aepedge-100"
    }}>{`iOS AEPEdge 1.0.0`}</h3>
    <p>{`Initial release of Adobe Experience Platform Edge Network mobile extension iOS in Swift.`}</p>
    <p>{`This extension allows for sending XDM formatted data to Adobe Experience Platform and Adobe Experience Cloud solutions, by leveraging Edge Network capabilities.`}</p>
    <p>{`The included features with this release are:`}</p>
    <ul>
      <li parentName="ul">{`Ability to create XDM Experience Events and send them to Experience Edge Network. An optional Experience Edge response callback can be registered per event.`}</li>
      <li parentName="ul">{`The XDM Experience Events can be sent to individual Adobe Experience Platform datasets when a custom dataset identifier is set at event level.`}</li>
      <li parentName="ul">{`Events persistence.`}</li>
      <li parentName="ul">{`ECID is automatically attached on each XDM Experience Event request.`}</li>
      <li parentName="ul">{`Integration with AEPAssurance extension enabling new insights in Project Griffon about the XDM Experience Event processing and XDM data validation for an improved validation and debugging experience.`}</li>
      <li parentName="ul">{`Detailed warning/error messages are available through Project Griffon UI and logs.`}</li>
    </ul>
    <p>{`This extension library is available as an open sourced project (`}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-edge-ios"
      }}>{`adobe/aepsdk-edge-ios`}</a>{`) on GitHub.`}</p>
    <p>{`These iOS libraries, written in Swift, are available for integration via SPM, XCFramework and Cocoapods and can be used in Swift and Objective-C applications.`}</p>
    <h3 {...{
      "id": "android-edge-100"
    }}>{`Android Edge 1.0.0`}</h3>
    <p>{`The Adobe Experience Platform Edge Network (Edge) mobile extension is now available in Android! This extension allows for sending XDM formatted data to Adobe Experience Platform and Adobe Experience Cloud solutions, by leveraging Experience Edge capabilities.`}</p>
    <p>{`The included features with this release are:`}</p>
    <ul>
      <li parentName="ul">{`Ability to create XDM Experience Events and send them to Experience Edge Network. An optional Experience Edge response callback can be registered per event.`}</li>
      <li parentName="ul">{`The XDM Experience Events can be sent to individual Adobe Experience Platform datasets when a custom dataset identifier is set at event level.`}</li>
      <li parentName="ul">{`ECID is automatically attached on each XDM Experience Event request.`}</li>
      <li parentName="ul">{`Integration with Assurance extension enabling new insights in Project Griffon about the XDM Experience Event processing and XDM data validation for an improved validation and debugging experience.`}</li>
      <li parentName="ul">{`Detailed warning/error messages are available through Project Griffon UI and logs.`}</li>
    </ul>
    <p>{`This SDK is compatible with Android Core 1.5.7 and above.`}</p>
    <h3 {...{
      "id": "adobe-experience-platform-edge-network-tag-extension-102"
    }}>{`Adobe Experience Platform Edge Network tag Extension 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Selector for the Edge Configuration.`}</li>
      <li parentName="ul">{`AEP Request Event with optional XDM event type is available for tag rules.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      